import React, {useState} from "react";
import './MainView.css';
import {Layout, Menu} from 'antd';
import {LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined, ProfileOutlined, HomeOutlined} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import {Link as RouterLink, useLocation, useRoutes} from "react-router-dom";
import {capitalizeFirstLetter} from "../utilities/functions";
import {useKeycloak} from "@react-keycloak/web";
import {useDispatch, useSelector} from "react-redux";
import {setUser, UserState} from "../state/userSlice";
import {useQuery} from "@apollo/client";
import {RootDispatch, RootState} from "../state/rootStore";
import Denied from "../components/Denied";
import {SELECT_PERSON_BY_KEYCLOAK_UUID} from "../backend/service/AccountService";
import {Person} from "../backend/entity/polon/Person";
import HomeView from "./HomeView";
import ElectiveChoiceView from "./ElectiveChoiceView";


const {Header, Sider, Content} = Layout;

function MainView() {
    const marginSmall = 80
    const margin = 200

    const {t} = useTranslation();
    const location = useLocation()
    const [collapsed, setCollapsed] = useState<string>('full')
    const {keycloak,} = useKeycloak();
    const dispatch = useDispatch<RootDispatch>()
    const user = useSelector<RootState, UserState>(state => state.userReducer)

    const toggle = () => {
        switch (collapsed) {
            case 'full':
                setCollapsed('small');
                return
            case 'small':
                setCollapsed('hidden');
                return;
            case 'hidden':
                setCollapsed('full')
        }

    };

    const onBreakpoint = (broken: boolean) => {
        broken ? setCollapsed('hidden') : setCollapsed('full')
    }

    let element = useRoutes([
        // These are the same as the props you provide to <Route>
        {path: '/', element: <HomeView/>},
        {path: '/elective', element: <ElectiveChoiceView person_id={user.personId}/>}
    ]);

    const userHandler = (user: UserState) => {
        dispatch(setUser(user))
    }

    const {loading, error, data} = useQuery<{ polon_person: Person[] }>(SELECT_PERSON_BY_KEYCLOAK_UUID, {
        pollInterval: 0,
        skip: keycloak.tokenParsed?.sub === undefined,
        variables: {
            keycloak_uuid: keycloak.tokenParsed?.sub
        }
    })

    if (!keycloak.hasResourceRole("student", "obieralne")) {
        return <Denied/>
    }

    if (loading) return <p>{t('database.loading')}</p>;
    if (error) return <p>{t('database.error')}</p>;
    // TODO problematic code below
    if (data && data.polon_person.length === 1) {
        userHandler({
            personId: data.polon_person[0].id,
            firstName: data.polon_person[0].first_name,
            lastName: data.polon_person[0].last_name,
            email: data.polon_person[0].person_accounts[0].email,
            keycloakUuid: keycloak.tokenParsed?.sub
        })
    }

    return (
        <Layout style={{minHeight: '100vh'}}>
            <Sider trigger={null} collapsible onBreakpoint={onBreakpoint}
                   collapsedWidth={collapsed === 'small' ? marginSmall : 0}
                   collapsed={collapsed === 'small' || collapsed === 'hidden'} breakpoint="lg"
                   style={{
                       overflow: 'auto',
                       height: '100vh',
                       position: 'fixed',
                       left: 0,
                       boxShadow: '0px 0px 2px'
                   }}
            >
                <div className="logo">
                    aMuz
                </div>
                <Menu theme="dark" mode="inline" defaultSelectedKeys={['/']} selectedKeys={[location.pathname]}>
                    <Menu.Item key="/">
                        <RouterLink to="/">
                            <HomeOutlined/>
                            <span>{capitalizeFirstLetter(t('main-view.home'))}</span>
                        </RouterLink>
                    </Menu.Item>
                    <Menu.Item key="/elective">
                        <RouterLink to="/elective">
                            <ProfileOutlined/>
                            <span>{capitalizeFirstLetter(t('main-view.electives'))}</span>
                        </RouterLink>
                    </Menu.Item>
                    <Menu.Item key="logout" icon={<LogoutOutlined/>} onClick={() => {
                        window.location.replace('https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=https://intramuz.amuz.gda.pl')
                    }}>
                        {capitalizeFirstLetter(t('main-view.logout'))}
                    </Menu.Item>
                </Menu>
            </Sider>
            <Layout className="site-layout"
                    style={{
                        marginLeft: collapsed === 'full' ? margin : (collapsed === 'small' ? marginSmall : 0),
                        transition: 'margin-left 0.25s'
                    }}
            >
                <Header className="site-layout-background"
                        style={{
                            padding: 0,
                            position: 'fixed',
                            width: '100%',
                            top: 0,
                            zIndex: 1000,
                            boxShadow: '0px 0px 2px'
                        }}
                >
                    {React.createElement(collapsed === 'hidden' ? MenuUnfoldOutlined : MenuFoldOutlined, {
                        className: 'trigger',
                        onClick: toggle,
                    })}
                    {t("app_name")} {user.firstName} {user.lastName}
                </Header>
                <Content
                    className="site-layout-background"
                    style={{
                        margin: '80px 12px 16px',
                        //margin: '64px 0px 0px',
                        padding: 24,
                        minHeight: 280,
                        // boxShadow: '1px 1px 4px'
                    }}
                >
                    {element}
                </Content>
            </Layout>
        </Layout>
    )
}

export default MainView